import React from 'react';
import PropTypes from 'prop-types';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';

import StatusText from './components/StatusText';

const TextByStatus = ({
  submissionResult,
  integrationType,
  comingFromView
}) => {
  const countyNames =
    submissionResult?.cwfData?.extraData?.purExtraData?.counties.map(
      c => c.name
    ) ?? [];

  switch (submissionResult?.httpStatusCode) {
    case 207:
      return (
        <StatusText title="Your data was partially sent due to a vendor integration issue.">
          <p className="font-normal text-sm">
            Your records were successfully created in this submission. However,
            some errors occurred with certain records. Please review the error
            reports here for more details.
          </p>
        </StatusText>
      );
    case 422:
      return (
        <StatusText title="Error reported in this submission.">
          <p className="font-normal text-sm">
            We were unable to send your data due to an integration error with
            the vendor {integrationType}. Please verify the errors in submission
            details.
          </p>
        </StatusText>
      );
    default:
      if (integrationType !== INTEGRATIONS.calAgPermits) {
        return (
          <StatusText
            title={`Your data has been ${comingFromView ? 're' : ''}submitted!`}
          >
            <p className="font-normal text-sm">
              Your submission has been sent to {integrationType}
              <br />
              You can view the submitted properties via the {
                integrationType
              }{' '}
              portal.
            </p>
          </StatusText>
        );
      }
      return (
        <StatusText title="You’re all set! We’ll take it from here.">
          <p className="font-normal text-sm">
            {`Your submission will be sent to the California Department of
            Agriculture for ${countyNames.join(', ')} ${
              countyNames.length > 1 ? 'counties' : 'county'
            }.`}
            <br />
            Depending on the quantity of applications, it may take up to a few
            hours to fully process.
            <br />
            You can view these via the CalAgPermits portal.
          </p>
        </StatusText>
      );
  }
};

TextByStatus.propTypes = {
  submissionResult: PropTypes.shape({
    httpStatusCode: PropTypes.number,
    id: PropTypes.string,
    cwfData: PropTypes.shape({
      extraData: PropTypes.shape({
        purExtraData: PropTypes.shape({
          counties: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string
            })
          )
        })
      })
    })
  }),
  integrationType: PropTypes.string,
  comingFromView: PropTypes.string
};

TextByStatus.defaultProps = {
  submissionResult: undefined,
  integrationType: '',
  comingFromView: ''
};

export default TextByStatus;
